export default "__VITE_ASSET__DQfdOyyi__"